const list = [
  {
    id: 1,
    title: '新媒体内容运营',
    type: '运营',
    experience: '三年以上工作经验',
    address: '深圳',
    date: '2024-04-16',
    work:['TO B产品内容运营:负责配合制定和执行的内容策略，负责主流新媒体平台（头条号、百家号、抖音、微信视频号、知乎等平台）的内容策划、创作与发布','对用户活跃及变现结果负责','能够完成日常图文、视频的选题、文案/脚本、排版/剪辑、分发、互动、数据分析等工作'],
    requirement: ['第一学历统招本科，1-3新媒体账号运营经验，有ToB业务账号运营经验者优先', '高度热爱新媒体/内容营销工作，熟悉抖音号、视频号等短视频平台的流量逻辑与规则', '良好的团队合作能力，能够在多元化团队环境中有效沟通；\n' +
    'PS：简历请附个人独立完成的图文、视频作品以及账号代表']
  },
  {
    id: 2,
    title: '运营商校园业务合作经理',
    type: '市场',
    experience: '三年以上工作经验',
    address: '石家庄/杭州/武汉/长沙/成都/重庆/大连/武汉/合肥',
    date: '2024-04-16',
    work:['根据公司战略和市场动态，制定并执行校园业务的商务拓展计划，负责拓展职教类院校的校园网及智慧校园业务','负责为公司引进并接入各地市运营商渠道资源，尤其与教育行业相关，确保校园WiFi快速落地并全面铺开','负责校园网及智慧校园等合作项目的全流程管理，包括勘查与可行性评估、方案编制与设计、网络开通与网络优化、项目建设后的宣传推广与用户管理等','负责校园网及智慧校园建设过程中整体成本控制以及获取用户的成本的有效管理','负责客情关系的维护以及客户对项目期望值的管理，协调资源，并及时解决项目执行过程中出现的各类问题'],
    requirement: ['本科及以上学历，3-5年商务拓展或销售经验，有成功案例者最佳，有做过校园网项目的优先', '熟悉运营商业务及校园市场，有运营商省市公司、区分公司或教育行业相关等渠道资源', '有通信设备安装、弱电、系统集成等相关项目实施和管理经验','对各种网络设备基本维护、路由器、交换机、防火墙、强弱电等有一定了解或者操作经验','良好的客户沟通、资源协调能力；良好的分析问题及解决问题能力；能接受出差']
  },

  {
    id: 3,
    title: '运营商校园业务合作发展总监',
    type: '市场',
    experience: '五年以上工作经验',
    address: '深圳',
    date: '2024-04-16',
    work:['负责制定和实施运营商校园业务合作发展战略，推动公司校园网及智慧校园业务在中高职院校市场的业务拓展和合作项目的落地','开拓并维护与运营商的合作关系，建立稳固的合作框架，推动双方合作项目的顺利推进','负责校园业务合作的谈判和合同签署，确保合作协议符合公司战略目标和利益最大化','跟踪行业动态和竞争对手的情况，及时调整业务发展策略，保持在校园市场的领先地位','负责团队建设和管理，培养和激励团队成员，确保团队目标的达成'],
    requirement:['本科及以上学历，市场营销、电信通信等相关专业优先','具有5年以上运营商校园业务合作发展相关工作经验，有运营商工作并负责校园业务经验者优先','具备较强的谈判能力和沟通能力，具备较强的团队管理能力和协调能力','具有较强的市场洞察力和业务拓展能力，熟悉校园市场运营模式和规律','具备较强的执行力和抗压能力，能够承受工作压力，有良好的团队合作精神']
  },

  {
    id: 4,
    title: '运维工程师',
    type: '运维',
    experience: '一年以上工作经验',
    address: '台州/西安',
    date: '2024-04-16',
    work:['负责所属区域内厂园WiFi项目的网络巡检及设备日常维护，确保设备离线率在公司规定的标准范围内','负责所属区域内厂园WiFi项目网络的优化与升级，并根据厂园的人员变化的具体情况进行宣传推广','负责所属区域项目维护工作，包括维护现用的微信用户，工单报修，电话回访，处理用户投诉与客情关系维护等','根据项目实际情况制定好项目运营维护计划和新业务执行'],
    requirement: ['计算机、通信、电子工程、软件工程、自动化等计算机相关专业，1年及以上相关经验','了解主流网络厂商产品，如cisco、华为、H3C、烽火等','熟悉linux基本操作指令，能熟练运用常用命令、熟悉网络通信基本原理及相关协议，对WLAN基本知识有一定的了解和认知的优先考虑','良好的人际沟通能力、自我管理能力强，能自我驱动'],
  },

]

export default list



// WEBPACK FOOTER //
// ./src/pages/about/recruitment.js